import { tv } from '../../lib/tv';
import { textInputStyles } from './text-input';

/**
 * Figma Date Field (93:11591) and Time Field (93:11617): the Text Input
 * Medium box (40 tall, radius/md, 12px sides, gap 8) with an 18px leading
 * icon. Open (`data-open`) = border/focus 1.5 + Focus/Input halo, like focus,
 * and the icon turns icon/brand. The value is Data/Medium (tabular); the
 * placeholder stays Body/Medium.
 */
export const pickerFieldStyles = tv({
  slots: {
    root: [
      textInputStyles({ size: 'md' }).root(),
      'group/picker cursor-text',
      'data-open:border-border-focus data-open:shadow-focus-input data-open:inset-ring-[0.5px] data-open:inset-ring-border-focus',
      'has-[input:disabled]:cursor-not-allowed',
    ],
    icon: [
      'text-icon-secondary size-[18px] shrink-0',
      'group-data-open/picker:text-icon-brand group-has-[input:disabled]/picker:text-icon-tertiary',
    ],
    input: 'text-data-md tabular-nums placeholder:font-normal',
  },
});

/**
 * Figma Time List (93:11618): bg/surface, border/subtle, radius/lg,
 * Shadow/MD, 6px padding, 212 tall (the cut-off last row says "more").
 * Slots 32 tall, radius/sm, 10px left / 8px right, Data/Medium; selected =
 * brand/subtle + text/brand + a 14px icon/brand check; hovered or active =
 * bg/muted.
 */
export const timeListStyles = tv({
  slots: {
    panel:
      'bg-bg-surface max-h-53 w-35 overflow-y-auto rounded-lg border border-border-subtle p-1.5 shadow-md outline-none focus-visible:ring-2 focus-visible:ring-border-focus',
    option: [
      'text-data-md text-text-primary flex h-8 cursor-default items-center rounded-sm pr-2 pl-2.5 tabular-nums select-none',
      'not-aria-selected:hover:bg-bg-muted not-aria-selected:data-active:bg-bg-muted',
      'aria-selected:bg-brand-subtle aria-selected:text-text-brand',
    ],
    label: 'min-w-0 flex-1 truncate',
    check: 'text-icon-brand size-3.5 shrink-0',
  },
});
